const $$splitComponentImporter = () => import('/Users/vthang/projects/marvy_mono/apps/pinktool/src/routes/_app/product-types.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { TbX } from "react-icons/tb";
import type { CreateProductTypeRequest, UpdateProductTypeRequest } from "@/api";
export const Route = createFileRoute("/_app/product-types")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
interface ProductTypeModalProps {
  isOpen: boolean;
  onClose: () => void;
  productType?: ProductType | null;
  onSuccess: () => void;
}